function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriangle = function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "210 0 540 540",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeMiterlimit: 10
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 10.45,
    fill: "currentColor",
    d: "M297.076 470.466V69.272c168.428 98.248 206.839 122.252 345.18 201.996-106.74 62.263-197.709 113.175-345.18 199.198Z",
    style: {
      fill: "none",
      strokeWidth: 40,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgTriangle;